import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Header from '../components/Header/Header';
import { trackMenuClick, trackEvent } from '../utils/analytics';
import { HOME_ROUTE_KEY } from '../utils/sessionStorageKeys';
import './LandingPage.css';

// URL qui ouvre dans l'app Google Maps sur mobile (maps.app.goo.gl)
const GOOGLE_MAPS_APP_URL = 'https://maps.app.goo.gl/GSM4UuLjRERhQo7CA';
// URL web directe pour écrire un avis
const GOOGLE_REVIEW_WEB_URL = 'https://g.page/r/CQU7-Ova2r9HEBI/review';

const LandingPage = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  useEffect(() => {
    if (!sessionStorage.getItem(HOME_ROUTE_KEY)) {
      sessionStorage.setItem(HOME_ROUTE_KEY, '/onSite');
    }
  }, []);

  const handleMenuClick = () => {
    trackMenuClick();
    navigate('/menuOnSite');
  };

  const handleReviewClick = () => {
    trackEvent('review_button_click', {
      event_category: 'engagement',
      event_label: 'Google Maps Review',
    });
    // Sur mobile, maps.app.goo.gl ouvre directement dans l'app Google Maps
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const url = isMobile ? GOOGLE_MAPS_APP_URL : GOOGLE_REVIEW_WEB_URL;
    window.location.href = url;
  };

  return (
    <div className="landing-page">
      <Header />
      <div className="landing-content">
        <h1 className="landing-restaurant-name">{t('aquaFarina')}</h1>
        <div className="landing-buttons">
          <button className="landing-button review-button" onClick={handleReviewClick}>
            <div className="landing-icon-wrapper reviews-stars">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 120 24"
                fill="#FFD700"
              >
                <path d="M12 2l2.4 7.2h7.6l-6 4.6 2.4 7.2L12 16.8l-6 4.4 2.4-7.2-6-4.6h7.6L12 2z" />
                <path d="M36 2l2.4 7.2h7.6l-6 4.6 2.4 7.2L36 16.8l-6 4.4 2.4-7.2-6-4.6h7.6L36 2z" />
                <path d="M60 2l2.4 7.2h7.6l-6 4.6 2.4 7.2L60 16.8l-6 4.4 2.4-7.2-6-4.6h7.6L60 2z" />
                <path d="M84 2l2.4 7.2h7.6l-6 4.6 2.4 7.2L84 16.8l-6 4.4 2.4-7.2-6-4.6h7.6L84 2z" />
                <path d="M108 2l2.4 7.2h7.6l-6 4.6 2.4 7.2L108 16.8l-6 4.4 2.4-7.2-6-4.6h7.6L108 2z" />
              </svg>
            </div>
            <span className="landing-label">{t('reviews')}</span>
          </button>

          <button className="landing-button menu-button" onClick={handleMenuClick}>
            <div className="landing-icon-wrapper">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
                <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
                <path d="M12 7v6" />
                <path d="M10 10h4" />
              </svg>
            </div>
            <span className="landing-label">{t('menu')}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
